import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from '../App';
import TermsOfUse from '../pages/TermsOfUse';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import DataDisclaimer from '../pages/DataDisclaimer';

export const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/data-disclaimer" element={<DataDisclaimer />} />
    </Routes>
  );
};

export default AppRouter;